export default __webpack_public_path__ + "static/media/pricing-startup.eecfbf55.jpg";